import {
  Box,
  Card,
  CardMedia,
  Container,
  Grid,
  Paper,
  Typography,
} from "@mui/material";

import { useEffect } from "react";

import wfpic1 from "../IMG_7321.jpeg";
import wfpic2 from "../IMG_7319.jpeg";
import wfpic3 from "../IMG_7318.jpeg";
import wfpic4 from "../IMG-20260705-WA0014.jpg";
import wfpic5 from "../IMG-20260705-WA0012.jpg";

export const WaterfrontCabin = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const photos = [wfpic2, wfpic3, wfpic4, wfpic5];

  return (
    <div className="page">
      <Container maxWidth="lg">
        <Typography
          variant="h3"
          align="center"
          gutterBottom
          sx={{ mt: 2, fontWeight: "bold" }}
        >
          Waterfront Cabin
        </Typography>

        <Typography
          variant="h6"
          align="center"
          color="text.secondary"
          sx={{ mb: 4 }}
        >
          Relax by the lake with beautiful waterfront views and peaceful
          evenings around the campfire.
        </Typography>

        {/* Hero Image */}
        <Card
          elevation={4}
          sx={{
            borderRadius: 3,
            overflow: "hidden",
            mb: 4,
          }}
        >
          <CardMedia
            component="img"
            image={wfpic1}
            alt="Waterfront Cabin"
            sx={{
              height: { xs: 250, sm: 400, md: 500 },
              objectFit: "cover",
            }}
          />
        </Card>

        {/* Description */}
        <Paper elevation={3} sx={{ p: 4, mb: 4 }}>
          <Typography variant="h5" gutterBottom>
            Experience the Lake
          </Typography>

          <Typography paragraph>
            Our waterfront cabin is situated right beside the lake with
            beautiful water views and easy access to the dock area and beach.
            It's an excellent choice for guests who enjoy spending their days
            near the waterfront and their evenings relaxing by the fire.
          </Typography>

          <Typography paragraph>
            During the daytime, the dock area in front of the cabin can be a
            popular spot for guests heading out on the water or enjoying the
            lakeshore. As a result, the cabin can sometimes feel less private
            during the daytime than our other accommodations.
          </Typography>

          <Typography paragraph>
            However, with no neighbouring campsites, the waterfront becomes exceptionally
            quiet at night. Enjoy a peaceful evening around your campfire while
            taking in the stars, and the sights and sounds of the lake.
          </Typography>
        </Paper>

        {/* Gallery */}
        <Typography variant="h4" align="center" gutterBottom>
          Photo Gallery
        </Typography>

        <Grid container spacing={3} sx={{ mb: 5 }}>
          {photos.map((photo, index) => (
            <Grid item xs={12} sm={6} key={index}>
              <Card elevation={3}>
                <CardMedia
                  component="img"
                  image={photo}
                  alt={`Waterfront Cabin ${index + 2}`}
                  sx={{
                    height: 300,
                    objectFit: "cover",
                  }}
                />
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* Cabin Information */}
        <Paper elevation={3} sx={{ p: 4, mb: 5 }}>
          <Typography variant="h5" gutterBottom>
            Good to Know
          </Typography>

          <Box sx={{ pl: 2 }}>
            <Typography paragraph>
              • Beautiful waterfront location with direct views of the lake.
            </Typography>

            <Typography paragraph>
              • The dock area is located directly in front of the cabin, so
              there is often activity nearby during the day.
            </Typography>

            <Typography paragraph>
              • Evenings are exceptionally peaceful, with no neighbouring
              campsites nearby. It is a great place to enjoy a quiet campfire by
              the water at night.
            </Typography>

            <Typography paragraph>
              • The park's main washroom building is approximately a 5-minute
              walk from the cabin.
            </Typography>

            <Typography paragraph>
              • An outhouse is conveniently located about a 30-second walk away
              for quick access.
            </Typography>

            <Typography paragraph>
              • Bedding is not provided, so you must bring your own pillows,
              blankets, sheets, etc.
            </Typography>

            <Typography paragraph>
              • The waterfront cabin has a queen bed, a small bar to eat at, two
              barstools, an electrical outlet, and two chairs on the front
              porch. Outside the cabin there is a firepit (with no grill), a
              picnic table, and a water tap.
            </Typography>

            <Typography paragraph>
              • $112 / night in peak season (June 12 - Sept. 6), $91 / night in
              value season (Sept. 7 - Oct. 12)
            </Typography>

            <Typography paragraph>
              • Our waterfront cabin is our only cabin that is not pet-friendly
            </Typography>
          </Box>
        </Paper>
      </Container>
    </div>
  );
};
